module.exports = __webpack_public_path__ + "static/media/projekt_logo_mali.e7829c80.svg";